export var getButtonView = function getButtonView(isActivePage, color) {
  if (isActivePage) {
    return 'tertiary';
  }
  return color === 'primary' ? 'secondary-on-primary' : 'secondary-on-secondary';
};